var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room"},[_c('blue-print',{attrs:{"bridgeId":_vm.bridgeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }